import { useState } from "react";
import Modal from "../../components/Modal";
import InputForm from "../../components/InputForm";

const MasterBpjsEdit = (props) => {
  const data = props.data;

  const [amount, setAmount] = useState(data.price ? data.price : 0);
  const submitHandler = () => {
    props.onConfirm({ id: data.id, amount });
  };

  const formatToIDR = (value) => {
    if (value == null || value === "") return "";
    return new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      minimumFractionDigits: 0,
    }).format(value);
  };

  const parseIDR = (formattedValue) => {
    if (!formattedValue) return 0;
    return Number(formattedValue.replace(/[^0-9]/g, ""));
  };

  const forms = [
    {
      margin: "mb-4",
      label: "Nominal",
      type: "text",
      id: "price",
      value: formatToIDR(amount),
      changeHandler: (val) => setAmount(parseIDR(val)),
    },
  ];

  return (
    <Modal
      activeModal={props.activeModal}
      title="Biaya Bulanan BPJS"
      closeClick={props.closeClick}
      submitHandler={submitHandler}
      type="Masukkan"
    >
      {forms.map((form) => (
        <InputForm key={form.id} {...form} />
      ))}
    </Modal>
  );
};

export default MasterBpjsEdit;
